import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AppRoutePath } from '../../../../app-route-path.enum';
import { EmptyStatesPath } from '../../../empty-states/empty-states-path.enum';
import { RoleFacade } from '../../role-facade/role.facade';

@Injectable({
  providedIn: 'root',
})
export class PricingRoleGuard implements CanActivate, CanActivateChild {
  private readonly router = inject(Router);
  private readonly roleFacade = inject(RoleFacade);

  canActivate(): Observable<boolean> {
    return this.checkPricingRole();
  }

  canActivateChild(): Observable<boolean> {
    return this.checkPricingRole();
  }

  private checkPricingRole(): Observable<boolean> {
    return this.roleFacade.hasAnyPricingRole$.pipe(
      tap(async (hasAnyPricingRole) => {
        if (!hasAnyPricingRole) {
          await this.router.navigate([
            AppRoutePath.EmptyStatesPath,
            EmptyStatesPath.ForbiddenPath,
          ]);
        }
      })
    );
  }
}
